import { MLSID, mlsInfoByShortName, syntaxFNMA } from '@aloft/toolkit-shared';

export function extractDataSourceDescription(sale: Element): {
  mls?: MLSID;
  mlsListingID?: string;
  daysOnMarket?: number;
} {
  try {
    const {
      mls: mlsRaw,
      listingID: mlsListingID,
      daysOnMarket,
    } = syntaxFNMA.dataSourceSyntax.decode(sale.getAttribute('DataSourceDescription') ?? '');
    const mlsInfo = mlsInfoByShortName(mlsRaw);
    const mls = mlsInfo?.mlsid;
    return {
      mls,
      mlsListingID,
      daysOnMarket,
    };
  } catch (e: unknown) {
    console.warn('Failed to parse data source', e);
    return {};
  }
}
